import { useQuery } from "@tanstack/react-query";
import { PrescriptionFormControllerApi } from "../../../../services";
import { getConfigObject } from "../../../../utils/utils";

/**
 * @author [Atish Bagate]
 */
interface Params {
  prescriptionFormId: string;
  xTENANTID?: string;
}

export const useGetPrescriptionById = ({
  prescriptionFormId,
  xTENANTID,
}: Params) =>
  useQuery({
    queryKey: ["prescription-form-by-id", prescriptionFormId, xTENANTID],
    queryFn: async () =>
      new PrescriptionFormControllerApi(getConfigObject())
        .getPrescriptionFormById(prescriptionFormId, xTENANTID)
        .then((it) => it?.data),
  });
